/**
 * Generates random number of digits of given length.
 * @param length Number of digits (characters) to be generate.
 * @returns Random number
 */
export function generateRandomNumber(length: number): number {
  return parseInt(
    Math.ceil(Math.random() * Date.now())
      .toPrecision(length)
      .toString()
      .replace('.', ''),
    10
  );
}

/**
 * Generates a random integer between a specified minimum (inclusive) and maximum (inclusive) value.
 *
 * @param min - The minimum value (inclusive).
 * @param max - The maximum value (inclusive).
 * @returns A random integer between the specified minimum and maximum values (inclusive).
 *
 * @example
 * const randomNum = getRandomIntInclusive(1, 10);
 * // Output: 5 (random number between 1 and 10, inclusive)
 */
export function getRandomIntInclusive(min: number, max: number): number {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive
}
